module.exports = __webpack_public_path__ + "img/processing_dark.5b6a7b3e.svg";